import React, { useState } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import {
	deleteContractOption,
	deleteVendorOption,
	downloadSegmentationData,
	getContractData,
	getGridData,
	getVendorSegmentationData,
	saveEditedVendorData,
	updateVendorContract,
	updateVendorSegmentation,
	validateSegmentationFile,
} from 'utils/apiRequests';
import { LoaderWrapper } from 'Benchmarks/Benchmarks.styles';
import {
	ApButtonIcon,
	ApButtonSecondary,
	ApLoaderDefault,
	ApLoaderText,
	ApSimpleDropdown,
	colors,
} from '@alixpartners/ui-components';
import Modal from '../Components/Modal';
import EditVendorData from './EditVendorData';
import { useCallback } from 'react';
import Dropzone from 'react-dropzone';
import {
	Button,
	ButtonWrapper,
	DatePicker,
	DateRangeWrapper,
	MainContent,
	Select,
	Ribbon,
	RibbonText,
	TableWrapper,
} from './VendorSegmentation.styles';
import { useEffect } from 'react';
import MonthPicker from 'Settings/FirstUsageSettings/MonthPicker';
import { useContext } from 'react';
import {
	DirectIndirectOptions,
	DirectTaxonomyTypeOptions,
	getCurrencySymbolFromOptions,
	getDateFormat,
	IndirectTaxonomyTypeOptions,
	SourceableTotalSpendOptions,
} from 'CategoryManagement/utils';
import { useMemo } from 'react';
import ConfirmModal from './ConfirmModal';
import { CategoryManagementContext } from 'contexts/CategoryManagementContext';
import ToggleSidebar from 'CategoryManagement/Components/ToggleSidebar/ToggleSidebar';
import CategorySidebarContent from 'CategoryManagement/Components/CategorySidebarContent/CategorySidebarContent';
import { formatSpendWithDecimalAndSymbol } from 'utils/number';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { formatPercentageToSingleDecimal } from 'CategoryManagement/Explore/DetailedAnalysis/utils';
import { SettingsOptionsContext } from 'contexts/SettingsOptionsContext';
import { SettingsContext } from 'contexts/SettingsContext';
import {
	DirectIndirectOptionsWrapper,
	SourceableTotalSpendOptionWrapper,
	TaxonomyTypeOptionWrapper,
} from 'CategoryManagement/Insights/Insights.styles';
import { getRequiredCustomFilterObjectFormat } from '../utils';

const VendorSegmentation = () => {
	const [rowData, setRowData] = useState([]);
	const [editedData, setEditedData] = useState([]);
	const [showSidebar, setShowSideBar] = useState(false);
	const [selectedSection, setSelectedSection] = useState(1);
	const [optionsChanged, setOptionsChanged] = useState([]);
	const [segmentation, setSegmentation] = useState([]);
	const [contract, setContract] = useState([]);
	const [gridApi, setGridApI] = useState(null);
	const [loading, setLoading] = useState(false);
	const [saving, setSaving] = useState(false);
	const [deleting, setDeleting] = useState(false);
	const [deleteSeg, setDeleteSeg] = useState(null);
	const [isCategorySidebar, setIsCategorySidebar] = useState(false);

	const {
		currentSelectCategory,
		dateRangeData,
		handleDateRangeChange,
		handleSegmentationUpdate,
		isDirect,
		isSourceable,
		taxonomyType,
		customFilters,
		customFiltersValues,
		handleSourceableTotalSpendChange,
		handleDirectIndirectChange,
		handleTaxonomyTypeChange,
	} = useContext(CategoryManagementContext);

	const {
		options: { currency: currencyList },
	} = useContext(SettingsOptionsContext);
	const { currency } = useContext(QueryStringContext);
	const currencySymbol = getCurrencySymbolFromOptions(currencyList, currency);
	const { hideDecimals } = useContext(SettingsContext);
	const [columnDefs, setColumnDefs] = useState([
		{
			headerName: 'Vendor Name',
			field: 'vendor_Name',
			filter: 'agTextColumnFilter',
			sortable: true,
		},
		{
			headerName: 'Preferred Vendor',
			field: 'is_Preferred',
			filter: 'agTextColumnFilter',
			cellEditor: 'agCheckboxCellEditor',
			cellStyle: { 'text-align': 'center' },
			cellRenderer: 'checkboxRenderer',
		},
		{
			headerName: 'Vendor Segmentation',
			field: 'vendor_Segmentation',
			filter: 'agTextColumnFilter',
			cellRenderer: 'dropdownRenderer1',
			sortable: true,
		},
		{
			headerName: 'Contract Info',
			field: 'contracts',
			filter: 'agTextColumnFilter',
			cellRenderer: 'dropdownRenderer2',
			sortable: true,
		},
		{
			headerName: 'Contract End  Date',
			field: 'preferred_Vendor_date',
			cellRenderer: 'dateRenderer',
			sortable: true,
		},
		{
			headerName: 'AP L4Category',
			field: 'l4Category',
			filter: 'agTextColumnFilter',
			sortable: true,
		},
		{
			headerName: 'Country',
			field: 'country',
			filter: 'agTextColumnFilter',
			sortable: true,
		},
		{
			headerName: 'Business Unit',
			field: 'bussiness_Units',
			filter: 'agTextColumnFilter',
			sortable: true,
		},
		{
			headerName: 'Total Spend',
			field: 'total_Spend',
			sortable: true,
			sort: 'desc',
			filter: 'agNumberColumnFilter',
			valueFormatter: params => {
				return formatSpendWithDecimalAndSymbol(
					params.value,
					currencySymbol,
					hideDecimals,
					2
				).toUpperCase();
			},
		},
		{
			headerName: '% of Total Spend',
			field: 'spend_Percentage',
			filter: 'agNumberColumnFilter',
			valueFormatter: params => {
				return formatPercentageToSingleDecimal(params.value);
			},
		},
	]);
	const minMaxDates = useMemo(() => getDateFormat(dateRangeData.stateRange), [
		dateRangeData.stateRange,
	]);
	const defaultGridHeight = { height: '75vh' };
	const gridStyle = useMemo(() => defaultGridHeight, [defaultGridHeight]);

	const onGridReady = useCallback(params => {
		setGridApI(params.api);
		params.api.forEachNode(row => {
			if (row.data.is_Preferred) {
				row.setSelected(true);
			}
		});
		params.api.sizeColumnsToFit();
	}, []);
	useEffect(
		() => {
			setColumnDefs(prevColumnDefs =>
				prevColumnDefs.map(
					col =>
						col.field === 'l4Category'
							? {
									...col,
									headerName:
										taxonomyType === 3 ? 'Client L4Category' : 'AP L4Category',
							  }
							: col
				)
			);
		},
		[taxonomyType]
	);

	const handleCellValueChange = event => {
		const selectedRowNodes = gridApi.getSelectedNodes();

		if (
			event.oldValue &&
			event.newValue &&
			event.oldValue.toString() === event.newValue.toString() &&
			selectedRowNodes.length === 1
		) {
			return;
		}

		const modifiedRows = [];

		modifiedRows.push(event.data);

		updateObjectById(event.data.concatenated_ids, event.data);
	};
	const updateObjectById = (id, newObject) => {
		setEditedData(prevState => {
			const existingIndex = prevState.findIndex(
				obj => obj.concatenated_ids === id
			);
			if (existingIndex !== -1) {
				const updatedState = [...prevState];
				updatedState[existingIndex] = newObject;
				return updatedState;
			} else {
				return [...prevState, newObject];
			}
		});
	};
	const DropdownRenderer1 = props => {
		const { value, setValue } = props;
		return (
			<Select
				options={segmentation}
				value={value}
				onChange={v => {
					setValue(v);
					onSegmentationChange(v, props.data.concatenated_ids);
				}}
				small={true}
			/>
		);
	};
	const DropdownRenderer2 = props => {
		const { value, setValue } = props;

		return (
			<Select
				options={contract}
				value={value}
				onChange={v => {
					setValue(v);
					onContractChange(v, props.data.concatenated_ids);
				}}
				small={true}
			/>
		);
	};
	const DateRenderer = props => {
		const { value, setValue } = props;
		const parts = value.split('T');
		const dateWithoutTime = parts[0];
		return (
			<DatePicker
				type="date"
				value={dateWithoutTime}
				onChange={e => {
					setValue(e.target.value);
					onDateChange(e.target.value, props.data.concatenated_ids);
				}}
			/>
		);
	};
	const CheckboxCellRenderer = props => {
		const { value, setValue } = props;
		return (
			<input
				type="checkbox"
				checked={value}
				onChange={e => {
					setValue(e.target.checked);
					onPrefferedChange(e.target.checked, props.data.concatenated_ids);
				}}
				style={{ marginTop: '10px' }}
			/>
		);
	};
	useEffect(
		() => {
			const dateRange = minMaxDates;
			const payload = {
				categoryName: currentSelectCategory.categoryName,
				isDirect: isDirect,
				isSourceable: isSourceable,
				taxonomyType: taxonomyType,
				...dateRange,
			};
			if (
				Array.isArray(customFiltersValues) &&
				customFiltersValues.length > 0
			) {
				payload.customfilter = getRequiredCustomFilterObjectFormat(
					customFilters,
					customFiltersValues
				);
			}
			setLoading(true);
			Promise.all([
				getVendorSegmentationData(),
				getContractData(),
				getGridData(payload),
			]).then(([segmentationResponse, contractResponse, gridResponse]) => {
				if (segmentationResponse.succeeded) {
					const convertedData = segmentationResponse.data
						.map(item => ({
							value: item.id,
							label: item.vendor_Segmentation_Name,
						}))
						// .filter(dataObj => dataObj.value !== 99)
						.sort((a, b) => a.value - b.value);

					setSegmentation(convertedData);
				}
				if (contractResponse.succeeded) {
					const convertedData = contractResponse.data
						.map(item => ({
							value: item.id,
							label: item.vendor_Contract_Name,
						}))
						// .filter(dataObj => dataObj.value !== 99)
						.sort((a, b) => a.value - b.value);

					setContract(convertedData);
				}

				if (gridResponse.succeeded) {
					setRowData(gridResponse.data);
				} else {
					setRowData([]);
				}

				setLoading(false);
			});
		},
		[
			optionsChanged,
			minMaxDates,
			currentSelectCategory,
			isDirect,
			isSourceable,
			taxonomyType,
			customFilters,
			customFiltersValues,
		]
	);
	const getGridOptions = () => {
		return {
			modules: AllModules,
			defaultColDef: {
				flex: 1,
				minWidth: 150,
				cellStyle: { fontSize: '13px' },
			},
			rowData,
			columnDefs,
			suppressCopyRowsToClipboard: true,
			suppressScrollOnNewData: true,
			suppressRowDrag: true,
			suppressRowClickSelection: true,
			suppressCellSelection: true,
			suppressCsvExport: true,
			suppressExcelExport: true,
			suppressContextMenu: true,
			suppressMultiSort: true,
			pagination: true,
			paginationPageSize: 50,
			rowStyle: { background: 'white' },
			applyColumnDefOrder: true,
			onGridReady: onGridReady,
			rowHeight: 40,
			onRowDataChanged: params => {
				params.api.sizeColumnsToFit();
			},
		};
	};

	const onSegmentationChange = (newValue, rowIndex) => {
		const foundItem = segmentation.find(
			item => Number(newValue) === item.value
		);
		const index = rowData.findIndex(obj => obj.concatenated_ids === rowIndex);
		setRowData(prev => {
			const update = [...prev];
			update[index].vendor_Segmentation = foundItem.value;
			return update;
		});
	};
	const onContractChange = (newValue, rowIndex) => {
		const foundItem = contract.find(item => Number(newValue) === item.value);
		const index = rowData.findIndex(obj => obj.concatenated_ids === rowIndex);
		setRowData(prev => {
			const update = [...prev];
			update[index].contracts = foundItem.value;
			return update;
		});
	};
	const onDateChange = (newValue, rowIndex) => {
		const index = rowData.findIndex(obj => obj.concatenated_ids === rowIndex);
		if (newValue !== '') {
			setRowData(prev => {
				const update = [...prev];
				update[index].preferred_Vendor_date = new Date(newValue).toISOString();
				return update;
			});
		}
	};
	const onPrefferedChange = (newValue, rowIndex) => {
		const index = rowData.findIndex(obj => obj.concatenated_ids === rowIndex);
		setRowData(prev => {
			const update = [...prev];
			update[index].is_Preferred = newValue;
			return update;
		});
	};

	const onFileSelected = acceptedFiles => {
		const file = acceptedFiles[0];
		validateSegmentationFile(file);
	};
	const updateVendorData = async updatedOptions => {
		if (selectedSection === 1) {
			const convertSegmentation = updatedOptions.map(item => ({
				id: item.value,
				vendor_Segmentation_Name: item.label,
			}));
			await updateVendorSegmentation(convertSegmentation);
			setOptionsChanged(convertSegmentation);
		} else {
			const convertContract = updatedOptions.map(item => ({
				id: item.value,
				vendor_Contract_Name: item.label,
			}));
			await updateVendorContract(convertContract);
			setOptionsChanged(convertContract);
		}
	};

	const deleteVendorData = async () => {
		if (selectedSection === 1) {
			const convertSegmentation = {
				id: deleteSeg.value,
				vendor_Segmentation_Name: deleteSeg.label,
			};
			await deleteVendorOption(convertSegmentation);
			setOptionsChanged(deleteSeg);
			setDeleteSeg(null);
		} else {
			const convertContract = {
				id: deleteSeg.value,
				vendor_Contract_Name: deleteSeg.label,
			};
			await deleteContractOption(convertContract);
			setOptionsChanged(deleteSeg);
			setDeleteSeg(null);
		}
	};
	const handleSectionClick = section => {
		setSelectedSection(section);
	};

	return loading || saving ? (
		<LoaderWrapper>
			<ApLoaderDefault loaderText={() => <ApLoaderText />} />
		</LoaderWrapper>
	) : (
		<MainContent>
			<div
				style={{
					display: 'flex',
					justifyContent: 'flex-end',
					padding: '5px 0',
					alignItems: 'center',
				}}
			>
				<Ribbon>
					<ApButtonIcon
						title="Add Category"
						iconName="add"
						iconProps={{ iconColor: colors.grey8 }}
						onClick={() => setIsCategorySidebar(true)}
						small={true}
					/>
					<RibbonText>
						{currentSelectCategory.categoryName === '/All/' ? (
							<>Category - All</>
						) : (
							<>
								L{decodeURI(currentSelectCategory.categoryName).split('/')
									.length - 2}
								Category -{' '}
								{decodeURIComponent(
									decodeURI(currentSelectCategory.categoryName).split('/')[
										decodeURI(currentSelectCategory.categoryName).split('/')
											.length - 2
									]
								)}
							</>
						)}
					</RibbonText>
				</Ribbon>
				<DateRangeWrapper>
					<MonthPicker
						srcRange={dateRangeData.srcRange}
						stateRange={dateRangeData.stateRange}
						onConfirm={handleDateRangeChange}
					/>
				</DateRangeWrapper>
				<DirectIndirectOptionsWrapper>
					<ApSimpleDropdown
						options={DirectIndirectOptions}
						selected={
							DirectIndirectOptions.filter(x => x.value === isDirect)?.[0]
						}
						onChange={e => handleDirectIndirectChange(e.value)}
					/>
				</DirectIndirectOptionsWrapper>
				<SourceableTotalSpendOptionWrapper>
					<ApSimpleDropdown
						options={SourceableTotalSpendOptions}
						selected={
							SourceableTotalSpendOptions.filter(
								x => x.value === isSourceable
							)?.[0]
						}
						onChange={e => handleSourceableTotalSpendChange(e.value)}
					/>
				</SourceableTotalSpendOptionWrapper>
				<TaxonomyTypeOptionWrapper>
					<ApSimpleDropdown
						options={
							isDirect === false
								? DirectTaxonomyTypeOptions
								: IndirectTaxonomyTypeOptions
						}
						selected={
							isDirect === false
								? DirectTaxonomyTypeOptions[0]
								: IndirectTaxonomyTypeOptions.filter(
										x => x.value === taxonomyType
								  )
						}
						onChange={e => handleTaxonomyTypeChange(e.value)}
					/>
				</TaxonomyTypeOptionWrapper>
				<ApButtonSecondary
					disabled={editedData.length === 0}
					onClick={() => {
						setSaving(true);
						saveEditedVendorData(editedData).then(response => {
							if (response.Successed) {
								setEditedData([]);
								gridApi.redrawRows();
								setSaving(false);
								handleSegmentationUpdate();
							} else {
								setSaving(false);
							}
						});
					}}
				>
					Save
				</ApButtonSecondary>
				<Dropzone onDrop={onFileSelected} style={{}} noKeyboard>
					{({ getRootProps, getInputProps }) => (
						<div {...getRootProps()}>
							<input {...getInputProps()} accept=".csv" />
							<ApButtonIcon disabled={true} iconName="upload_outlined" />
						</div>
					)}
				</Dropzone>
				<ApButtonIcon
					iconName="download"
					onClick={() => downloadSegmentationData(minMaxDates)}
				/>

				<ApButtonIcon
					iconName="baseline_tune"
					iconProps={{ iconColor: colors.grey8 }}
					onClick={() => setShowSideBar(prev => !prev)}
				/>
			</div>
			{segmentation.length > 1 &&
				contract.length > 1 && (
					<TableWrapper>
						<div style={gridStyle} className="ag-theme-balham">
							<AgGridReact
								{...getGridOptions()}
								rowData={rowData}
								columnDefs={columnDefs}
								frameworkComponents={{
									dropdownRenderer1: DropdownRenderer1,
									dropdownRenderer2: DropdownRenderer2,
									dateRenderer: DateRenderer,
									checkboxRenderer: CheckboxCellRenderer,
								}}
								onGridReady={onGridReady}
								onCellValueChanged={handleCellValueChange}
							/>
						</div>
					</TableWrapper>
				)}
			{deleting && (
				<ConfirmModal
					isOpen={deleting}
					onClose={() => setDeleting(false)}
					deleteVendorData={deleteVendorData}
				>
					<div style={{ paddingRight: '5px' }}>
						Are you sure you want to delete the record.The changes cannot be
						reverted back.Instead try renaming the record.
					</div>
				</ConfirmModal>
			)}
			{!deleting &&
				showSidebar && (
					<Modal
						heading="Segmentation Settings"
						show={showSidebar}
						handleClose={() => setShowSideBar(false)}
					>
						<ButtonWrapper>
							<Button
								isSelected={selectedSection === 1}
								onClick={() => {
									handleSectionClick(1);
								}}
							>
								Vendor Segmentation
							</Button>
							<Button
								isSelected={selectedSection === 2}
								onClick={() => {
									handleSectionClick(2);
								}}
							>
								Contract Segmentation
							</Button>
						</ButtonWrapper>
						{selectedSection &&
							segmentation && (
								<EditVendorData
									updateVendorData={updateVendorData}
									onClose={setShowSideBar}
									setShowSideBar={setShowSideBar}
									data={selectedSection === 1 ? segmentation : contract}
									setDeleting={setDeleting}
									setDeleteSeg={setDeleteSeg}
								/>
							)}
					</Modal>
				)}
			<ToggleSidebar
				key={0}
				id={0}
				name={'category'}
				heading={'Categories'}
				show={isCategorySidebar}
				handleClose={setIsCategorySidebar}
				width={'24%'}
				toRight={false}
			>
				<CategorySidebarContent />
			</ToggleSidebar>
		</MainContent>
	);
};

export default VendorSegmentation;
